<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container">
<p class="imaget"><img alt="image" src="images/titlepg.png"/></p>
</div>
<p class="title4">A<span class="small">N</span> A<span class="small">LLEGORICAL</span> T<span class="small">ALE OF</span> D<span class="small">EVELOPING</span> L<span class="small">EADERSHIP</span> S<span class="small">KILLS IN</span> B<span class="small">USINESS AND IN</span> L<span class="small">IFE</span></p>
<p class="author"><b>S. Mosby Marble</b></p>
<p class="publisheri"><img alt="image" src="images/pub.png"/></p>
<p class="publisher">NEW YORK</p>
<p class="publishers">LONDON • NASHVILLE • MELBOURNE • VANCOUVER</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?73875ac0